<!--
 * @Description: 申请开票弹窗
 * @Author: yeqing
 * @Date: 2021-9-7 17:35:30
 * @LastEditTime:
 * @LastEditors:
-->
<template>
  <a-modal :visible="isVisible" title="申请发票" @cancel="handleCancel" @ok="handleSubmit" ok-text="确认" :confirmLoading="loading" class="invoice-modal cr-fs-md" width="540px">
    <div class="desc-box cr-text-primary">电子发票与纸质发票具有同等法律效力，如需开具纸质发票或有其他发票问题请拨打400-6868-802联系我们。</div>
    <a-form-model ref="applyForm" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" labelAlign="left" class="cr-mt-2">
      <a-form-model-item label="发票类型">
        <div class="cr-pl-1">增值税普通电子发票</div>
      </a-form-model-item>
      <a-form-model-item label="发票内容">
        <a-select default-value="技术服务费" v-model="form.content">
          <a-select-option :value="0"> 技术服务费 </a-select-option>
          <a-select-option :value="1"> 服务费 </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="发票金额">
        <div class="cr-pl-1 money">
          <span class="cr-text-amount">{{ invoiceInfo.applyAmount && invoiceInfo.applyAmount.toFixed(2) }}</span> 元
        </div>
      </a-form-model-item>
      <a-form-model-item label="接收邮箱" prop="receiveMail">
        <a-input placeholder="请输入" v-model="form.receiveMail" />
      </a-form-model-item>
      <a-form-model-item label="发票抬头" prop="title">
        <a-input placeholder="请输入" v-model="form.title" />
      </a-form-model-item>
      <a-form-model-item label="纳税号" prop="identifyNo">
        <a-input placeholder="请输入" v-model="form.identifyNo" />
      </a-form-model-item>
      <a-form-model-item label="公司地址">
        <a-input placeholder="请输入公司地址（非必填）" v-model="form.companyAddress" />
      </a-form-model-item>
      <a-form-model-item label="备案电话">
        <a-input placeholder="请输入备案电话（非必填）" v-model="form.companyPhone" />
      </a-form-model-item>
      <a-form-model-item label="开户银行">
        <a-input placeholder="请输入开户银行（非必填）" v-model="form.openingBank" />
      </a-form-model-item>
      <a-form-model-item label="银行账户">
        <a-input placeholder="请输入银行账户（非必填）" v-model="form.bankAccount" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { applyInvoice, applyInvoiceAgain } from '@/api/billManage'
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    invoiceInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        openingBank: '', // 开户银行
        bankAccount: '', // 开户账号
        companyAddress: '', // 公司地址
        identifyNo: '', // 纳税号
        companyPhone: '', // 公司电话
        title: '', // 发票抬头
        receiveMail: '', // 接受邮箱
        content: 0, //发票内容
        caseIdList: []
      },
      loading: false,
      rules: {
        receiveMail: [{ required: true, message: '请输入接收邮箱!' }],
        title: [{ required: true, message: '请输入发票抬头!' }],
        identifyNo: [{ required: true, message: '请输入纳税号!' }]
      }
    }
  },
  watch: {
    isVisible: {
      handler(item1) {
        if (item1) {
          this.form.title = this.invoiceInfo.title
          this.form.openingBank = this.invoiceInfo.accountBank
          this.form.bankAccount = this.invoiceInfo.accountNo
          this.form.identifyNo = this.invoiceInfo.identifyNo
          this.form.companyAddress = this.invoiceInfo.address
          this.form.companyPhone = this.invoiceInfo.mobile
          this.form.caseIdList = this.invoiceInfo.applyBillIdList
          this.invoiceInfo.invoiceNo ? (this.form.invoiceNo = this.invoiceInfo.invoiceNo) : ''
          this.form.receiveMail = this.invoiceInfo.receiveMail
        }
      }
    }
  },

  methods: {
    // 关闭
    handleCancel() {
      this.$emit('update:isVisible', false)
    },
    // 提交
    handleSubmit() {
      this.$refs.applyForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          let res = this.invoiceInfo.invoiceNo
            ? await applyInvoiceAgain({ ...this.form }).catch(() => {
                this.loading = false
              })
            : await applyInvoice({ ...this.form }).catch(() => {
                this.loading = false
              })
          this.loading = false
          if (res.code == 0) {
            this.$message.success('申请成功!')
            this.$emit('update:isVisible', false)
            this.$emit('refresh')
          } else {
            //  this.form = this.invoiceInfo
          }
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.invoice-modal {
  .desc-box {
    line-height: 20px;
    padding: 10px 16px 10px 14px;
    background: @item-selected;
  }
  .money {
    span {
      font-weight: bold;
    }
  }
  ::v-deep .ant-form-item {
    margin-bottom: 12px;
  }
  ::v-deep .ant-select-selection {
    border: none;
  }
  ::v-deep .ant-select-selection__rendered {
    margin-left: 10px;
  }
  ::v-deep form .ant-select {
    width: 110px;
  }
  ::v-deep.ant-form-item-label {
    > label::before {
      display: inline-block;
      margin-right: 4px;
      width: 7px;
      content: '';
    }
  }
  ::v-deep.ant-form-item-required::before {
    content: '*' !important;
    color: @cr-text-red;
  }
  ::v-deep.ant-input {
    width: 389px;
  }
}
</style>
